<template>
    <div id="login-panel">
        <div id="login-header">
            <h1 class="text-center">
                SensorCLIP
            </h1>
        </div>

        <div class="panel-container">

            <div id="lang">
                <language-switcher></language-switcher>
            </div>

            <div class="front panel" v-if="container == 'login'">
                <form action="#" id="login_form" method="post">
                    <div id="error" class="alert alert-danger" v-if="error">
                        {{ error }}
                    </div>
                    <div class="alert alert-success" v-if="justRegistered">
                        Din konto er nu oprettet. Vent venligst imens vi logger dig ind.
                    </div>
                    <div class="alert alert-info" v-if="sessionTimeout">
                        Du er automatisk blevet logget ud.
                    </div>

                    <div class="form-group">
                        <label class="control-label" for="email">{{ $t('label.email') }}</label>
                        <input name="email" type="text" v-model="username" id="email" class="form-control" value=""
                               autofocus="autofocus" tabindex="1" placeholder="test@example.com">
                    </div>
                    <div class="form-group">
                        <label class="control-label">
                            {{ $t('label.password') }}
                        </label>
                        <input name="passwd" type="password" v-model="password" class="form-control" value=""
                               tabindex="2" placeholder="Adgangskode">
                    </div>
                    <div class="form-group row-padding-top">
                        <button @click.stop.prevent="handleLogin" tabindex="4"
                                class="btn btn-primary btn-lg btn-block ladda-button btn-login"
                                v-bind:class="{disabled: isWorking}"
                                :disabled="isWorking">
                            <span class="ladda-label" v-if="!isWorking">
                               {{ $t('login.btn_login', 'Login') }}
                            </span><span class="ladda-label" v-if="isWorking">
                                {{ $t('processing') }}
                            </span>
                        </button>
                    </div>
                    <div class="form-group">

                        <a href="#" @click.prevent="setContainer('register')" class="show-forgfot-password pull-left">
                            {{ $t('login.btn_create_account') }}
                        </a>
                        <a href="#" @click.prevent="setContainer('recover')" class="show-forgfot-password pull-right">
                            {{ $t('login.btn_reset_pwd') }}
                        </a>
                    </div>
                </form>
            </div>
            <panel-recover v-if="container == 'recover'" @back="setContainer('login')"></panel-recover>
            <panel-register v-if="container == 'register'" @back="setContainer('login')"
                            @registered="handleNewlyRegistered"></panel-register>
        </div>

    </div>
</template>

<script>
    import auth from "../../utils/auth"
    import user from "../../user"
    import config from "../../config"
    import panelRegister from "./register.vue"
    import panelRecover from "./recover.vue"
    import languageSwitcher from "../layout/snippets/language-switcher.vue"
    import cookie from 'vue-cookie'

    export default {
        components: {panelRegister, panelRecover, languageSwitcher},
        name: 'login',
        data() {
            return {
                error: "",
                username: "",
                password: "",
                working: false,
                justRegistered: false,
                container: "login"
            }
        },
        computed: {
            isWorking() {
                return this.working;
            },
            sessionTimeout(){
                let expiration = cookie.get("token_expires");

                if(expiration !== null) {
                    return !auth.isInFuture(expiration)
                }
                return false
            }
        },
        methods: {
            setContainer(target) {
                this.error = "";
                this.justRegistered = false;
                this.container = target;
            },
            displayError(event) {
                this.error = event.message;
            },
            handleNewlyRegistered(event) {
                this.username = event.email;
                this.password = event.password;
                this.setContainer("login");
                this.justRegistered = true;
                this.handleLogin();
            },
            handleLogin() {
                this.error = "";

                // Validate empty input
                if (this.username.trim().length == 0 || this.password.trim().length == 1) {
                    this.error = "Udfyld venligst alle felter"
                    return;
                }

                this.working = true;
                this.$rest.post("token", {
                    application: config.app_id,
                    application_secret: config.app_secret,
                    username: this.username,
                    password: this.password
                })
                    .then(function (response) {
                        auth.login(this.username, response.data);
                    }.bind(this))
                    .catch(function (error) {
                        if (error.response) {
                            if (error.response.data.type === "UnauthenticatedClient")
                                this.error = "Forkert brugernavn eller adgangskode";
                            else
                                this.error = error.response.data.message;
                        } else {
                            this.error = "Der opstod en fejl og du kunne ikke logges på";
                        }
                        this.$store.commit("failedLogin")
                    }.bind(this))
                    .finally(() => {
                        this.justRegistered = false;
                        this.working = false;
                    });
            }
        }
    }
</script>

<style lang="scss" scoped>
    #login-panel {
        margin: 0 auto;
        width: 500px;
    }

    #login-header {
        padding-top: 100px;
        margin-bottom: 30px;
        color: #6d6d6d;
    }

    // Title
    #login-panel .panel-container {
        height: 420px;
        margin-top: 55px;
        position: relative;
    }

    #login-header h1 {
        margin: 0;
        padding: 0;
        color: #929292;
    }

    .text-center {
        text-align: center;
    }

    h1 {
        margin-top: 17px;
        margin-bottom: 8.5px;
        font-family: Helvetica, Arial, sans-serif;
        font-weight: 400;
        line-height: 1.1;
        font-size: 31px;
    }

    h4 {
        margin-bottom: 20px;
    }

    // Boxes
    #login-panel .front,
    #login-panel .back {
        width: 100%;
        padding: 40px;
        position: absolute;
        top: 0;
        -webkit-backface-visibility: hidden;
        -moz-backface-visibility: hidden;
        backface-visibility: hidden;
        left: 0;
    }

    #login-panel .panel {

        margin-bottom: 17px;
        background-color: #fff;
        border: 1px solid rgba(0, 0, 0, 0);

        -webkit-border-radius: 0;
        border-radius: 0;
        -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    }

    // Input fields
    .form-control,
    input[type="text"],
    input[type="password"],
    textarea,
    select {
        display: block;
        width: 100%;
        font-size: 12px;
        line-height: 1.42857;
        color: #555;
        background-color: #F5F8F9;
        background-image: none;
        border: 1px solid #C7D6DB;
        border-radius: 3px;
        font-family: "Open Sans", Helvetica, Arial, sans-serif, "FontAwesome" !important;
        height: inherit !important;
        padding: 10px 8px !important;
    }

    // Login button
    .btn-login {
        padding: 10px 16px;
        font-size: 15px;
        line-height: 1.33;
        border-radius: 3px;
    }

    .btn-login:hover {
        background-color: #008abd;
        -webkit-box-shadow: none;
        box-shadow: none;
        cursor: pointer;
    }

    // Links
    .form-group {
        margin-bottom: 15px;
    }

    a {
        color: #2c7b9c;
        text-decoration: none;
    }

    @media (max-width: 480px) {
        #login-panel {
            width: 90%;
        }
    }

    // Language switcher
    #lang {
        position: absolute;
        right: 0px;
        top: -35px;
    }
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue